import { stitch } from 'keo';
import PropTypes from 'prop-types';
import r from 'render-dom';
import { SubmissionError } from 'redux-form';

import { signup } from 'redux/me/actions';

import SignUp from './SignUp';

const propTypes = { hasSignedUp: PropTypes.bool.isRequired };

const render = ({ props }) => {
    return r(SignUp, {
        hasSignedUp: props.hasSignedUp,
        location: props.location,
        onSubmit: (values) => props.signup(values).then(
            Function.prototype,
            (err) => { throw new SubmissionError(err); }
        ),
    });
};

export default stitch(
    { propTypes, render },
    ({ me }) => ({ hasSignedUp: me.get('hasSignedUp') }),
    { signup }
);



// WEBPACK FOOTER //
// ./src/components/public/SignUp/index.js